'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Donut = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _systemComponents = require('system-components');
var _systemComponents2 = _interopRequireDefault(_systemComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var DonutBase = function DonutBase(props) {
  var R = 16 - props.strokeWidth;
  var C = 2 * Math.PI * R;
  return _react2["default"].createElement('svg', _extends({}, props, {
    viewBox: '0 0 32 32',
    width: props.size || 128,
    height: props.size || 128
  }), _react2["default"].createElement('circle', {
    cx: 16,
    cy: 16,
    r: R,
    fill: 'none',
    stroke: 'currentcolor',
    strokeWidth: props.strokeWidth,
    opacity: '0.125'
  }), _react2["default"].createElement('circle', {
    cx: 16,
    cy: 16,
    r: R,
    fill: 'none',
    stroke: 'currentcolor',
    strokeWidth: props.strokeWidth,
    strokeDasharray: C,
    strokeDashoffset: C - props.value * C,
    transform: 'rotate(-90 16 16)'
  }));
};
var Donut = exports.Donut = (0, _systemComponents2["default"])({
  is: DonutBase,
  color: 'blue',
  strokeWidth: 2,
  value: 1
}, 'space', 'color');
Donut.displayName = 'Donut';
exports["default"] = Donut;